import api from 'api';

export const startJob = async ({ file }) => {
  return await api(`POST /api/tapjoy-bid-update/start`)(file);
};
export const stopJob = api(`POST /api/tapjoy-bid-update/stop`);
export const loadStatus = api(`GET /api/tapjoy-bid-update/status`);
export const loadErrorDetails = api(`GET /api/tapjoy-bid-update/error-details`);
export const downloadErrorFile = api('GET /api/tapjoy-bid-update/error-file', {
  responseType: 'blob',
});

export const loadAutoUpdateViaAPI = api(
  `GET /api/tapjoy-bid-update/auto-update-via-api`
);
export const setIsAllowExternalAPI = api(
  `POST /api/tapjoy-bid-update/set-auto-update-via-api`
);
